<template>
  <div>
    <!-- 协议升级表格 -->
    <el-table :data="list.value" border style="width: 100%">
      <el-table-column prop="id" label="id" width="50"></el-table-column>
      <el-table-column prop="agreementName" label="协议名称"></el-table-column>
      <el-table-column prop="agreementVersion" label="协议版本"></el-table-column>
      <el-table-column prop="senderPlatforms" label="发端"></el-table-column>
      <el-table-column prop="receiverPlatforms" label="收端">
      </el-table-column>
      <el-table-column prop="updateTime" label="开始时间"></el-table-column>
      <el-table-column prop="remark" label="说明"></el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button v-auth="'PROTOCOL_COMPLIANCE_PROTOCOL_UPDATE_VIEW'" type="text" size="small"
            @click="view(scope.row.id)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <ElementPagination style="margin-bottom: 20px;" :total="searchParams.total" :current="searchParams.current"
      :size="searchParams.size" :pageSizes="[10, 20, 100]" @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </ElementPagination>
    <Add ref="add"></Add>
  </div>
</template>

<script>
import ElementPagination from '@/components/ElementPagination';
import Message from '@/components/Message'
import Add from './add.vue'
import { getProtocolUpdateDetail } from '@/api/protocolCompliance/protocolUpdate'
export default {
  name: 'WebSaaSTable',
  components: {
    ElementPagination,
    Add
  },
  inject: ['searchParams', 'list', 'loadList', 'sendPlatform', 'receivePlatform'],
  data() {
    return {

    };
  },

  methods: {
    //^ ^--------------表格操作栏的事件-------------^ ^
    /** 查看 */
    async view(id) {
      console.log('查看', id);
      const { data } = await getProtocolUpdateDetail(Number(id))
      console.log('获取协议升级策略详情的响应', data);
      this.$refs.add.show('view', data.data);
    },
    //^ ^--------------分页相关-------------^ ^
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      this.loadList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 更新数据 */
      this.loadList();
    },
  },
};
</script>

<style lang="scss" scoped></style>
